export class AccessLinkRequestForbiddenError extends Error {}
